import {observer_mgl} from "mobx-graphlink";
import React from "react";
import {RowLR, Text, TextInput} from "react-vcomponents";
import {ObjModifier} from "../../../../../Server/DB/mapObjects/@MapObject/ObjModifier.js";
import {Mod_TerrainRegion} from "../../../../../Server/DB/mapObjects/@MapObject/ObjModifiers/Mod_TerrainRegion.js";
import {ModifierUI_SharedProps} from "../Modifiers_CompUI.js";

const splitAt = 100;
export const TerrainRegion_ModUI = observer_mgl((props: {mod: ObjModifier} & ModifierUI_SharedProps)=>{
	const {modWrapper: mod, ChangeModWrapper: ChangeMod} = props;
	const Change = (mutator: (data: Mod_TerrainRegion)=>any)=>ChangeMod(a=>mutator(a.terrainRegion!));
	const data = mod.terrainRegion!;

	return (
		<>
			<RowLR mt={5} splitAt={splitAt}>
				<Text>Terrain ID:</Text>
				<TextInput value={data.terrainID} onChange={val=>Change(a=>a.terrainID = val)}/>
			</RowLR>
		</>
	);
});